import * as React from 'react';
import { Table, Dropdown, Modal, Button, Segment, Dimmer, Loader, Input, Icon, Label } from 'semantic-ui-react';
import Group from '../../sys/group-set';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { DataRequest } from '../../api';
import ReactTable from 'react-table';
import CustomPagination from '../../sys/pagination';
import { default as Renderers } from '../../sys/columns';
import PortalView from '../portal';
import ManifestView from '../manifest';
import { Link, NavLink } from 'react-router-dom';
import MIMEHeaderView from '../mimeHeader';
import MediaFileView from '../media-file-stats';
import { Response } from '../../api/request';
import * as ReactTooltip from 'react-tooltip';
// import TestDetailsView from './testDetails';

const FontAwesome = require('react-fontawesome');

class State {
    queuedSet: any;
    inProgressSet: any;
    completedSet: any;
    showModal: boolean;
    stream: any;
    streamId: number;
    streamName: string;
    columns: any;
    singleData: any;
    groups: Array<string>;
    showManifestWindow: boolean;
    showMIMEHeaderWindow: boolean;
    showMediaFileWindow: boolean;
    showTestDetailsWindow: boolean;
    alias: string;
    pass: number;
    fail: number;
    error: number;
    stateFilter: any;
    eventTypeFilter: string[];
    eventTypeFilterText: string[];
    eventTypeFilterAll: boolean;
    eventTypeClicked: boolean;
    refreshRate ?: number;
}

interface Props {
}

export default class VodStatusView extends React.Component<Props, State> {

    protected columnSets = {
        // the underscore set is always added to the View at the beginning
        _: [
            {
                width: 40,
                align: 'center',
                Cell: (props: any) => this.buttonRenderer(props)
            }, {
                Header: 'Stream',
                accessor: 'name',
                width: 350
            }
        ],
        Summary: [
            {
                Header: (h: any) => (<span>Result</span>),
                accessor: 'statistics.summary',
                width: 120,
                align: 'right',
                Cell: (props: any) => this.passFailRenderer(props, false)
            }, {
                Header: (h: any) => (<span> Content <br/> Duration <br/> (hh:mm:ss)</span>),
                accessor: 'statistics.vod.duration',
                type: 'timestamp.calendar',
                width: 120,
                align: 'right',
                Cell: (props: any) => Renderers.timestamp.durationHMS(props.value, false)
            }, {
                Header: (h: any) => (<span>Test <br/> Duration  <br/> (hh:mm:ss)</span>),
                accessor: 'statistics.summary',
                type: 'timestamp.calendar',
                width: 280,
                align: 'right',
                Cell: (props: any) => this.calculateTimeout(props)
            // }, {
            //     Header: (h: any) => (<span>Errors</span>),
            //     accessor: 'statistics.summary',
            //     width: 120,
            //     align: 'right',
            //     Cell: (props: any) => this.totalErrors(props, false)
            }
        ],
        Accessibility: [{
            Header: (h: any) => (<span>Server <br/> Changes</span>),
            accessor: 'statistics.connection',
            width: 100,
            align: 'right',
            Cell: (props: any) => this.serverChangeRenderer(props.value),
        }, {
            Header: (h: any) => (<span>Derived<br/>Variant Start<br/>Time (sec)</span>),
            accessor: 'statistics.timing.dvst',
            width: 120,
            align: 'right',
            type: 'secToMsec'
        }, {
            Header: (h: any) => (<span>DNS<br/>Time<br/>(ms)</span>),
            accessor: 'statistics.connection.dns.time.current',
            width: 70,
            align: 'right',
            //   Cell: (props: any) => this.commonAlarmMsecRenderer(props, 0x00000040, 0),
        }, {
            Header: (h: any) => (<span>Connection<br/>Time<br/>(ms)</span>),
            accessor: 'statistics.connection.time.current',
            width: 100,
            align: 'right',
            //   Cell: (props: any) => this.commonAlarmMsecRenderer(props, 0x00000008, 0),
        }, {
            Header: (h: any) => <span>DNS Errors<br/>Query<br/>Failure</span>,
            accessor: 'statistics.connection.dns.errors',
            width: 115,
            align: 'right',
            //    Cell: (props: any) => this.commonAlarm0Renderer(props, 0x00200000, 0),
        }, {
            Header: (h: any) => <span>TCP<br/>Connection<br/>Error</span>,
            accessor: 'statistics.connection.errors',
            width: 105,
            align: 'right',
            //    Cell: (props: any) => this.commonAlarmRenderer(props, 0x08000000, 1),
        }, {
            Header: (h: any) => (<span>Expiration <br/> Error</span>),
            accessor: 'statistics.summary.errors.vodErrors.expirationErr',
            width: 120,
            align: 'right',
            Cell: (props: any) => this.booleanErrRenderer(props)
        }],
        HTTP: [{
            Header: (h: any) => (
                <div>
                    <div className="title">HTTP Codes</div>
                    <div className="http totals -header">
                        <div className="http2xxBox-empty">2xx</div>
                        <div className="http3xxBox-empty">3xx</div>
                        <div className="http4xxBox-empty">4xx</div>
                        <div className="http5xxBox-empty">5xx</div>
                        <div className="outline" title="close">CL</div>
                        <div className="outline" title="socket and other">OT</div>
                    </div>
                </div>
            ),
            accessor: 'statistics.http',
            type: 'http',
            width: 245,
            align: 'left',
            className: 'group-first group-last'
        }],
        MediaFiles: [{
                Header: (h: any) => <span>Total<br/>KBytes</span>,
                accessor: 'statistics.files.media.totalBytes',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.bytesToKbRenderer(props),
                //    aggregate: 'blank'
            }, {
                Header: (h: any) => <span>Bitrate<br/>(kbps)</span>,
                accessor: 'statistics.files.media.bitrate.current',
                width: 90,
                align: 'right',
                Cell: (props: any) => this.bytesToKbRenderer(props),
                //   aggregate: 'blank'
            }, {
                Header: (h: any) => <span>Download<br/>Rate<br/>(kbps)</span>,
                accessor: 'statistics.files.media.download.rate.current',
                width: 90,
                align: 'right',
                Cell: (props: any) => this.bytesToKbRenderer(props)
            }, {
                Header: (h: any) => (<span>Duration<br/> Error</span>),
                accessor: 'statistics.vod.durationErr',
                width: 120,
                align: 'right',
                Cell: (props: any) => this.booleanErrRenderer(props)
        }],
        ABRProtocol:
            [{
                Header: (h: any) => <span>Profile<br/>Count<br/>Error</span>,
                accessor: 'statistics.files.manifest.profCntErr',
                width: 70,
                align: 'right',
                //    Cell: (props: any) => this.commonAlarmRenderer(props, 0x80000000, 1),
            }, {
                Header: (h: any) => <span>Playlist<br/>Unavailable<br/>Error</span>,
                accessor: 'statistics.files.manifest.unaErr', // '/ unaConsErr'
                width: 95,
                align: 'right',
                //    Cell: (props: any) => this.commonAlarmRenderer(props, 0x00000200, 1)
            }, {
                Header: (h: any) => <span>Sequence<br/>Errors<br/>Total</span>,
                accessor: 'statistics.files.media.sequence.errors',
                width: 85,
                align: 'right',
                //    Cell: (props: any) => this.checkMaster(props, 0x02000000, 0),
            }, {
                Header: (h: any) => <span>Video/Audio<br/>Sync<br/>Errors</span>,
                accessor: 'statistics.files.media.video.videoAudioSyncErrors',
                width: 100,
                align: 'right',
                //    Cell: (props: any) => this.checkNA(props, 0x00001000, 0),
            }, {
                Header: (h: any) => <span>Decryption<br/>Errors</span>,
                accessor: 'statistics.files.media.decrypt.errors',
                width: 90,
                align: 'right',
                //   Cell: (props: any) => this.checkNA(props, 0x00000800, 0)
            }, {
                Header: (h: any) => <span>Audio<br/>Not<br/>Present</span>,
                accessor: 'statistics.files.media.audio.NPErrors',
                width: 70,
                align: 'center',
                //    Cell: (props: any) => this.checkNA(props, 0x00000400, 0)
            }, {
                Header: (h: any) => <span>Media<br/>Files<br/>Requested</span>,
                accessor: 'statistics.files.media.download.rate.samples',
                width: 90,
                align: 'right',
                //    Cell: (props: any) => this.commaRenderer(props)
            }, {
                Header: (h: any) => <span>Total<br/>Media<br/>Files</span>,
                accessor: 'statistics.files.media.totalFiles',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.commaRenderer(props),
                //    aggregate: 'blank'
            }, {
                Header: (h: any) => (<span>Asset <br/> Type <br/> Error</span>),
                accessor: 'statistics.summary.errors.vodErrors.assetTypeErr',
                width: 120,
                align: 'right',
                Cell: (props: any) => this.booleanErrRenderer(props)
            }],
        QOE:
            [{
                Header: () => this.headerRenderer((<span>Video<br/>MOS</span>), 'Type: Average <br /> Period: 10 seconds <br /> Detail: Mean opinion score (1-5) for video content'),
                accessor: 'statistics.qoe.mos.video.current',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00080000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Still<br/>Frame</span>), 'Type: Percentage <br /> Period: Most recent video segment <br /> Detail: Percent of the video frame without motion'),
                accessor: 'statistics.qoe.gop.stillness.current',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00020000, 1),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Black<br/>Screen</span>), 'Type: Percentage <br /> Period: Most recent video segment <br /> Detail: Percent of the video frame that is black'),
                    accessor: 'statistics.qoe.gop.blackness.current',
                    width: 70,
                    align: 'right',
                    aggregate: 'blank',
                    Cell: (props: any) => this.checkQoEMedia(props, 0x00040000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Audio<br/>MOS</span>), 'Type: Average <br /> Period: 10 seconds <br /> Detail: Mean opinion score (1-5) for audio content'),
                    accessor: 'statistics.qoe.mos.audio.current',
                    width: 70,
                    align: 'right',
                    aggregate: 'blank',
                    Cell: (props: any) => this.checkQoEMedia(props, 0x00000002, 1)
            // }, {
            //     Header: () => this.headerRenderer((<span>Channels</span>), 'Type: Count <br /> Period: Most recent audio segment <br /> Detail: Audio channels detected'),
            //         accessor: 'status.audioParams.channels',
            //         width: 85,
            //         align: 'right',
            //         aggregate: 'blank',
            //         Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 1)
            }, {
                Header: () => this.headerRenderer((<span>Loudness<br/>(LKFS)</span>), 'Type: Measured average<br/>Period: Last 10 seconds of audio<br/>Detail: Loudness K-weighted relative to full scale'),
                    accessor: 'statistics.qoe.audio.loudness.current',
                    width: 85,
                    align: 'right',
                    aggregate: 'blank',
                    Cell: (props: any) => this.checkQoEMedia(props, 0x01000000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Dialnorm<br/>(LU)</span>), 'Type: Metadata<br/>Period: Last 10 seconds of audio<br/>Detail: Average dialog normalization level from the media'),
                    accessor: 'statistics.qoe.audio.dialnorm.current',
                    width: 85,
                    align: 'right',
                    aggregate: 'blank',
                    Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 0)
            }, {
                Header: () => this.headerRenderer((<span>Dialnorm<br/>Deviation<br/>(LU)</span>), 'Type: Calculated<br/>Period: Most recent audio segment<br/>Detail: Measured loudness deviation from the received dialnorm metadata'),
                    accessor: 'statistics.qoe.audio.loudnessDnDev.current',
                    width: 85,
                    align: 'right',
                    aggregate: 'blank',
                    Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 0)
            }]
    };

    // static isCompleted(item: any) {
    //     return (item.state === 'PASS' || item.state === 'FAIL' || item.state === 'ERROR');
    // }

    static isFullyCompleted(item: any) {
        // must contain stats & status to be considered fully completed.
        return ((item.status && item.statistics && item.statistics.summary) && (item.statistics.summary.assetResult === 'PASS' || item.statistics.summary.assetResult === 'FAIL' || item.statistics.summary.assetResult === 'ERROR'));
    }

    static isPassed(item: any) {
        return (item.statistics.summary.assetResult === 'PASS'); // No errors/alarms.
    }

    static isFailed(item: any) {
        return (item.statistics.summary.assetResult === 'FAIL'); // Errors/Alarms
    }

    static isErrored(item: any) {
        return (item.statistics.summary.assetResult === 'ERROR'); // Test start/initialization errors.
    }

    // static isOutage(item: any) {
    //     return (item.statistics.summary.outage.count);
    // }

    static transformData(data: any) {
        // collect the list of master VOD records
        if (data && data.results && data.results.vod) {
            let resultSet: [] = data.results.vod;

            // split the records into Queued, In-Progress, and Completed.
            let queuedSet: any[] = [], inProgressSet: any[] = [], completedSet: any[] = [];
            let pass: number = 0, fail: number = 0, error: number = 0;

            resultSet.forEach((item: any) => {
                if (VodStatusView.isFullyCompleted(item)) {
                    completedSet.push(item);
                    if (VodStatusView.isPassed(item)) {
                        pass++;
                    } else if (VodStatusView.isFailed(item)) {
                        fail++;
                    } else if (VodStatusView.isErrored(item)) {
                        error++;
                    }
                } else if (item.state === 'IDLE')
                    queuedSet.push(item);
                else
                    inProgressSet.push(item);
            });

            // return the new data structure
            return {queuedSet, inProgressSet, completedSet, pass, fail, error};
        } else
            return undefined;
    }

    headerRenderer(header: any, headerText: string) {
        return (
            <div>
                <span data-tip={headerText} data-for="headerTip">
                    {header}
                </span>
                <ReactTooltip id="headerTip" place="top" effect="solid" html={true} />
            </div>
        );
    }

    checkQoEMedia(props: any, bitMap: any, index: number): React.ReactNode {
        let clsName = '';
        let value = props.value;

        if (props.original.statistics && props.original.statistics.summary) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (props.original.statistics && props.original.statistics.qoe) {
            if (props.column.id === 'statistics.qoe.mos.video.current') {
                if (props.original.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.videoEnabled === true && props.original.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'statistics.qoe.mos.audio.current') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioEnabled === true && props.original.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'statistics.qoe.audio.loudness.current') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioEnabled === true && props.original.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props.value === undefined) {
                        value = 0;
                    } else {
                        if (props.value === 0) {
                            value = props.value;
                        } else {
                            value = props.value.toFixed(2);
                        }
                    }
                }
            } else if (props.column.id === 'status.audioParams.channels') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioEnabled === true && props.original.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'statistics.qoe.audio.dialnorm.current') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioEnabled === true && props.original.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'statistics.qoe.audio.loudnessDnDev.current') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioEnabled === true && props.original.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'statistics.qoe.gop.stillness.current') {
                if (props.original.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.videoEnabled === true && props.original.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'statistics.qoe.gop.blackness.current') {
                if (props.original.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.videoEnabled === true && props.original.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props.value;
                }
            }
        } else {
            value = '-'; clsName = '';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        if (props.column.id === 'statistics.qoe.audio.loudnessDnDev.current' && clsName !== 'iq-td-alarm-disabled') {
            return(
                <div className={clsName}>
                    <span style={inlineStyle}> {value} </span>
                </div>
            );
        } else {
            if (props.column.id === 'statistics.qoe.audio.loudnessDnDev.current' && clsName === 'iq-td-alarm-disabled') {
                return(
                    <div className={clsName} data-tip="Unsupported Codec">
                        {this.tooltipRenderer()}
                        <span style={inlineStyle}> - </span>
                    </div>
                );
            } else {
                if (clsName === 'iq-td-alarm-disabled') {
                    return (
                        <div className={clsName} data-tip="Unsupported Codec">
                            {this.tooltipRenderer()}
                            -
                        </div>
                    );
                } else {
                    return (
                        <div className={clsName}>
                            {value}
                        </div>
                    );
                }
            }
        }
    }

    getAlarmHighlight(props: any, bitMap: any, index: number) {
        let clsName = '';
        let activeAlarmField = props.original.statistics.summary.errors.active[index];
        let monitoredAlarmField = props.original.statistics.summary.errors.monitored[index];
        let historyAlarmField = props.original.statistics.summary.errors.history[index];

        // tslint:disable-next-line:no-bitwise
        if ((monitoredAlarmField & bitMap) !== 0) {
            // tslint:disable-next-line:no-bitwise
            if ((activeAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-critical';
                // tslint:disable-next-line:no-bitwise
            } else if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = 'iq-td-status-clear';
            }
        } else {
            // tslint:disable-next-line:no-bitwise
            if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = '';
            }
        }

        if (clsName === '') {
            if (props.column.id === 'statistics.qoe.audio.loudness.current') {
                bitMap = 0x00400000; index = 1;
                activeAlarmField = props.original.statistics.summary.errors.active[index];
                monitoredAlarmField = props.original.statistics.summary.errors.monitored[index];
                historyAlarmField = props.original.statistics.summary.errors.history[index];

                // tslint:disable-next-line:no-bitwise
                if ((monitoredAlarmField & bitMap) !== 0) {
                    // tslint:disable-next-line:no-bitwise
                    if ((activeAlarmField & bitMap) !== 0) {
                        clsName = 'iq-td-alarm-critical';
                        // tslint:disable-next-line:no-bitwise
                    } else if ((historyAlarmField & bitMap) !== 0) {
                        clsName = 'iq-td-alarm-minr';
                    } else {
                        clsName = 'iq-td-status-clear';
                    }
                } else {
                    // tslint:disable-next-line:no-bitwise
                    if ((historyAlarmField & bitMap) !== 0) {
                        clsName = 'iq-td-alarm-minr';
                    } else {
                        clsName = '';
                    }
                }
            }
        }
        return clsName;
    }

    componentWillMount() {
        this.setState({
            groups: ['Summary'],
            queuedSet: '',
            showManifestWindow: false,
            showMIMEHeaderWindow: false,
            showMediaFileWindow: false,
            showTestDetailsWindow: false,
            inProgressSet: '',
            completedSet: '',
            showModal: false,
            stream: '',
            columns: ['Summary'],
            singleData: '',
            alias: '',
            pass: 0,
            fail: 0,
            error: 0,
            stateFilter: '',
            eventTypeFilter: [],
            eventTypeFilterText: [],
            eventTypeFilterAll: false,
            eventTypeClicked: false,
            refreshRate: 5000
        });
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleEventTypeCheckbox = this.handleEventTypeCheckbox.bind(this);
        // process shortcuts in the columns sets into fields ready for React Table
        Renderers.ReactTable(this.columnSets);
    }
    componentDidMount() {

        this.openManifestWindowPortal = this.openManifestWindowPortal.bind(this);
        this.closeManifestWindowPortal = this.closeManifestWindowPortal.bind(this);

        this.openMIMEHeaderWindowPortal = this.openMIMEHeaderWindowPortal.bind(this);
        this.closeMIMEHeaderWindowPortal = this.closeMIMEHeaderWindowPortal.bind(this);

        this.openMediaFileWindowPortal = this.openMediaFileWindowPortal.bind(this);
        this.closeMediaFileWindowPortal = this.closeMediaFileWindowPortal.bind(this);

        this.openTestDetailsWindowPortal = this.openTestDetailsWindowPortal.bind(this);
        this.closeTestDetailsWindowPortal = this.closeTestDetailsWindowPortal.bind(this);

        window.addEventListener('beforeunload', () => {
            this.closeMIMEHeaderWindowPortal();
            this.closeManifestWindowPortal();
            this.closeMediaFileWindowPortal();
            this.closeTestDetailsWindowPortal();
        });
    }
    openTestDetailsWindowPortal() {
        this.setState(state => ({
            ...state,
            showTestDetailsWindow: true
        }));
    }
    closeTestDetailsWindowPortal() {
        this.setState({ showTestDetailsWindow: false });
    }
    openManifestWindowPortal() {
        this.setState(state => ({
            ...state,
            showManifestWindow: true
        }));
    }
    closeManifestWindowPortal() {
        this.setState({ showManifestWindow: false });
    }
    openMIMEHeaderWindowPortal() {
        this.setState(state => ({
            ...state,
            showMIMEHeaderWindow: true
        }));
    }
    closeMIMEHeaderWindowPortal() {
        this.setState({ showMIMEHeaderWindow: false });
    }
    openMediaFileWindowPortal() {
        this.setState(state => ({
            ...state,
            showMediaFileWindow: true
        }));
    }
    closeMediaFileWindowPortal() {
        this.setState({ showMediaFileWindow: false });
    }

    openManifestWindow(props: any, variant: boolean) {
        let streamId: number;
        let streamName: string;

        if (variant) {
            streamId = props.original.id.vodId;
            streamName = props.original.name;
        } else {
            streamId = props.id.vodId;
            streamName = props.name;
        }
        this.setState({
            streamId: streamId,
            streamName: streamName,
        },            () =>
            this.openManifestWindowPortal());
    }
    openMIMEHeaderWindow(props: any) {
        this.setState({
            streamId: props.original.id.vodId,
            streamName: props.original.name
        },            () =>
            this.openMIMEHeaderWindowPortal());
    }
    openMediaFileWindow(props: any) {
        this.setState({
            streamId: props.original.id.vodId,
            streamName: props.original.name
        },            () =>
            this.openMediaFileWindowPortal());

    }

    handleClick(object: any) {
        this.setState({
            stream: object
        },            () => this.setState({showModal: true}));
    }

    handleModalClose() {
        this.setState({
            groups: ['Summary'],
            showModal: false
        });
    }

    fetchSingleStreamData(stream: any) {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/analytics';
        axios.post(url, {
            'aliases': 'name',
            'name': stream.name,
            'timerange': '100 to current',
            'namespace': 'api.surveyor.abr',
            'metrics': ['vod']
        })
            .then(function (response: AxiosResponse) {
                if (response.data.results) {
                    __this.setState({
                        singleData: response.data.results.vod
                    });
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
                //    __this.scheduleNextUpdate();
            });
    }
    setRefreshInterval(interval?: number) {
        this.setState({ refreshRate: interval });
    }
    handleEventTypeCheckbox(e: any, data: any, option: any, entryTypeOptions: any) {
        let prevRefreshRate = this.state.refreshRate;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        let tempFilterArray: string[] = this.state.eventTypeFilter;
        let tempFilterTextArray: string[] = this.state.eventTypeFilterText;
        let tempOptionsArray: object[] = entryTypeOptions;
        tempOptionsArray.shift();
        let tempOptionsStringArray: string[] = tempOptionsArray.map((a: any) => a.value);
        let tempOptionsArrayText: string[] = tempOptionsArray.map((a: any) => a.text);

        if ( option.value === 'all') {
            this.setState({eventTypeFilterAll: data.checked});
            // tslint:disable-next-line:no-unused-expression
            data.checked ?
                (tempFilterArray = tempOptionsStringArray) && (tempFilterTextArray = tempOptionsArrayText)  :
                (tempFilterArray = []) && (tempFilterTextArray = []);
        } else {
            // tslint:disable-next-line:no-unused-expression
            data.checked ?
                tempFilterArray.push(option.value) && tempFilterTextArray.push(option.text) :
                (tempFilterArray = tempFilterArray.filter(item => item !== option.value)) &&
                (tempFilterTextArray = tempFilterTextArray.filter(item => item !== option.text));
        }
        // console.log(tempFilterTextArray);
        this.setState({ eventTypeFilter: tempFilterArray, eventTypeFilterText: tempFilterTextArray});
    }
    buttonRenderer(props: any): React.ReactNode {
        return ( // TODO: This menu does not show up if the list is long and you are looking at the last few assets in the list.
            <div className="cellIcons">
                <Dropdown item icon="bars" >
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => this.openManifestWindow(props, true)}>Manifests</Dropdown.Item>
                        <Dropdown.Item onClick={() => this.openMediaFileWindow(props)}>Media Files</Dropdown.Item>
                        <Dropdown.Item onClick={() => this.openMIMEHeaderWindow(props)}>MIME Headers</Dropdown.Item>
                        <Dropdown.Divider />
                        {props.original && props.original.id && <Dropdown.Item as={Link} to={{ pathname: '/logs/transaction', state: { streamid: props.original.id.streamId, name: props.original.name} }}>Transaction Log</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
    serverChangeRenderer(props: any) {
        return (props.manifest.IPChanges + ' / ' + props.media.IPChanges);
    }
    bytesToKbRenderer(props: any): React.ReactNode {
        return (
            <div>{Renderers.bytesToKB(props.value)}</div>
        );
    }
    // timeOutTimeRenderer(props: any) {
    //     if (props !== 0) {
    //         let utcSeconds = props;
    //         let d = new Date(0); // The 0 sets the date to the epoch.
    //         d.setUTCSeconds(utcSeconds);
    //         return d.toString();
    //     } else {
    //         return '-';
    //     }
    //
    // }
    commaRenderer(props: any): React.ReactNode {
        let value = Renderers.commaSeparated(props.value);
        /* if (props.original.status.master)
            value =  '-';
        */
        return (
            <div>{value}</div>
        );
    }
    booleanErrRenderer(props: any): React.ReactNode {
        let value = props.value;
        if (value === 0 || value === false) {
            return (
                <div>No</div>
            );
        } else {
            return (
                <div className="label-red">Yes</div>
            );
        }
    }
    // passFailResult(props: any, master: boolean): boolean {
    //     let value;
    //     if (!master) {
    //         value = props.result;
    //     } else {
    //         value = props.result;
    //         if (value !== 'FAIL') {
    //             if (this.state.singleData[0] && this.state.singleData[0].variants) {
    //                 for (let i = 0; i < this.state.singleData[0].variants.length; i++) {
    //                     if (this.state.singleData[0].variants[i].statistics.summary.result !== 'PASS') {
    //                         value = 'FAIL';
    //                         break;
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     if (value === 'PASS') {
    //         // vod.statistics.summary.errors.vodErrors: assetTypeErr, durationErr, expirationErr, timeoutErrType[]
    //         // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:max-line-length
    //         if (!((props.errors.vodErrors.assetTypeErr === false || props.errors.vodErrors.assetTypeErr === 0) && (props.errors.vodErrors.expirationErr === false || props.errors.vodErrors.expirationErr === 0) && (props.errors.vodErrors.durationErr === false || props.errors.vodErrors.durationErr === 0) && (props.errors.vodErrors.timeoutErrType.length === 0))) {
    //             value = 'FAIL';
    //         }
    //     }
    //     if (value === 'PASS' || value === 'Pass') {
    //         return false;
    //     } else {
    //         return true;
    //     }
    // }
    // Not used.
    passFailRenderer(props: any, master: boolean): React.ReactNode {
        let value; let errorString;

        if (!master) {
            value = props.value.result;
            errorString = props.value.errors.binMnemonic;
        } else {
            value = props.assetResult;
            errorString = props.errors.binMnemonic;
        }

        if (value === 'PASS' || value === 'Pass') {
            return (
                <div>Pass</div>
            );
        } else {
            return (
                <div data-tip={errorString !== '' ? 'Alarms: ' + errorString : ''} className="label-red">
                    Fail
                    {this.tooltipRenderer()}
                </div>
            );
        }
    }
    errorsText(props: any): React.ReactNode {
        let errorString = props.errors.binMnemonic !== '' ? props.errors.binMnemonic : ''; // master binMnemonic
        let asset = props.assetResult;

        return (
            <div className="label-red">{errorString !== '' ? errorString : asset !== 'PASS' ? 'See Variants below for more details on alarms/errors.' : ''}</div>
        );
    }
    // calculateDuration(props: any): React.ReactNode {
    //     let duration;
    //
    //     if (props.original.statistics && props.original.statistics.summary) {
    //         duration = Renderers.timestamp.durationHMS(props.original.statistics.summary.stopTime - props.original.statistics.summary.startTime, false);
    //         if (props.original.statistics.vod.durationErr === 0) {
    //             return (
    //                 <div>{duration}</div>
    //             );
    //         } else {
    //             return (
    //                 <div className="label-red">{duration}</div>
    //             );
    //         }
    //     } else {
    //         return(
    //             <div>'-'</div>
    //         );
    //     }
    // }
    displayTimeout(value: any) {
        let retStr = '';
        switch (value[0]) {
            case 'outage':
                retStr = 'TIMEOUT: Stream in outage';
                break;
            case 'advance':
                retStr = 'TIMEOUT: Stream advance test too long';
                break;
            case 'full stream':
                retStr = 'TIMEOUT: Full stream test too long';
                break;
            case 'schedule mode':
                retStr = 'TIMEOUT: Schedule time exceeded';
                break;
            default:
                retStr = '-';
                break;
        }
        return retStr;
    }
    calculateTimeout(props: any): React.ReactNode {
        let duration;

        if (props.original.statistics && props.original.statistics.summary) {
            duration = Renderers.timestamp.durationHMS(props.original.statistics.summary.stopTime - props.original.statistics.summary.startTime, false);
            if (props.original.statistics.vod.timeoutErrType.length > 0) {
                return (
                    <div className="label-red">{this.displayTimeout(props.original.statistics.vod.timeoutErrType)}</div>
                );
            } else {
                return (
                    <div>{duration}</div>
                );
            }
        } else {
            return(
                <div>'-'</div>
            );
        }
    }
    tooltipRenderer() {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={250} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }
    // totalErrors(props: any, master: boolean): React.ReactNode {
    //     let errCount = 0; let tmpErrCount; let errorString;
    //     if (!master) {
    //         errorString = props.original.statistics.summary.errors.binMnemonic;
    //         // count the number of errors in the "errors.binMnemonic" string.
    //         if (errorString.indexOf(',') > -1) {
    //             tmpErrCount = errorString.split(',').length - 1;
    //             if (!(tmpErrCount === 0)) errCount += tmpErrCount + 1;
    //         } else {
    //             if (errorString.length > 0) {
    //                 errCount++;
    //             }
    //         }
    //     } else {
    //         errorString = props.errors.binMnemonic;
    //         // count the number of errors in the "errors.binMnemonic" string.
    //         if (errorString.indexOf(',') > -1) {
    //             tmpErrCount = errorString.split(',').length - 1;
    //             if (!(tmpErrCount === 0)) errCount += tmpErrCount + 1;
    //         } else {
    //             if (errorString.length > 0) {
    //                 errCount++;
    //             }
    //         }
    //         if (this.state.singleData[0] && this.state.singleData[0].variants) {
    //             for (let i = 0; i < this.state.singleData[0].variants.length; i++) {
    //                 if (this.state.singleData[0].variants[i].statistics.summary.result !== 'PASS') {
    //                     errorString = this.state.singleData[0].variants[i].statistics.summary.errors.binMnemonic;
    //                     // count the number of errors in the "errors.binMnemonic" string.
    //                     if (errorString.indexOf(',') > -1) {
    //                         tmpErrCount = errorString.split(',').length - 1;
    //                         if (!(tmpErrCount === 0)) errCount += tmpErrCount + 1;
    //                     } else {
    //                         if (errorString.length > 0) {
    //                             errCount++;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //
    //     if (!(errCount > 0)) {
    //         return (
    //             <div>
    //                 {errCount}
    //             </div>
    //         );
    //     } else {
    //         if (!master) {
    //             return (
    //                 <div data-tip={errorString} className="label-red">
    //                     {errCount}
    //                     {this.tooltipRenderer()}
    //                 </div>
    //             );
    //         } else {
    //             return (
    //                 <div className="label-red">{errCount}</div>
    //             );
    //         }
    //     }
    // }
    buildColumns(groupColumns: boolean, columnSetSelection: string | Array<string>) {
        /* Use the collection of column sets to build the set of columns to be shown.
         * Each string in the parameter columnSetSelection array will pick a set from the columnSets collection.
         */
        let columns: Array<object> = [];    // our output set

        if (typeof columnSetSelection === 'string') {
            // expect comma-delimited string, convert string to array of values
            columnSetSelection = columnSetSelection.split(',');
        }

        // push the main columns that are always on
        if (this.columnSets._ !== undefined)
            columns.push.apply(columns, this.columnSets._);

        // build set of columns based on selected groups
        for (let i = 0; i < columnSetSelection.length; i++) {
            // little hack to always include general columns is to start this loop at -1
            let columnLabel = columnSetSelection[i];

            if (this.columnSets[columnLabel] !== undefined) {
                /* figure out how we are going to add the columns to the view,
                 * we can add as flat collection of columns, grouped columns, or by an alternate view
                 */

                if (groupColumns) {
                    // add as grouped columns as per our original column sets
                    columns.push({
                        Header: columnLabel,
                        columns: this.columnSets[columnLabel]
                    });
                } else
                // a little hack to not require a loop; we call the .apply() to specify the arguments to
                // push as an array which we already conveniently have.
                    columns.push.apply(columns, this.columnSets[columnLabel]);
            }
        }
        return columns;
    }
    formatMode(str: string) {
        // FILE:ALL TIME:NORMAL REQ:GET
        let index = 0; let subStr1 = ''; let subStr2 = ''; let strVar = '';
        var array = str.split(' ');
        for (let i = 0; i < array.length; i++) {
            index = array[i].indexOf(':');
            if (index > 0) {
                subStr1 = array[i].substr(0, index + 2);
                subStr2 = array[i].substr(index + 2);
                if (!array[i].startsWith('REQ')) {
                    subStr2 = subStr2.toLowerCase();
                    strVar += subStr1 + subStr2 + ', ';
                } else {
                    strVar += subStr1 + subStr2;
                }
            }
        }
        return strVar;
    }

    renderDLSizeMB(manifestBytes: number) {
        let totalMB = manifestBytes;
        if (this.state.singleData[0] && this.state.singleData[0].variants) {
            for (let i = 0; i < this.state.singleData[0].variants.length; i++) {
                totalMB += this.state.singleData[0].variants[i].statistics.files.manifest.bytes;
                totalMB += this.state.singleData[0].variants[i].statistics.files.media.totalBytes;
            }
        }
        return Renderers.bytesOnlyValue(totalMB);
    }

    streamState(stream: any, type: number) {
        if (stream.statistics && stream.statistics.summary) {
            if (stream.statistics.summary.assetResult !== 'PASS') {
                if (stream.statistics.summary.outage.count > 0 || this.variantOutages(stream) > 0) {
                    return type === 1 ? 'Outage' : 'black';
                } else {
                    return (stream.statistics.summary.assetResult === 'FAIL' ? (type === 1 ? 'Fail' : 'red') : (type === 1 ? 'Error' : 'orange'));
                }
            } else {
                return type === 1 ? 'Good' : 'green';
            }
        } else {
            return type === 1 ? 'Unknown' : '';
        }
    }

    variantOutages(props: any) {
        let result = 0;
        if (props.variants) {
            for (let i = 0; i < props.variants.length; i++) {
                if (props.variants[i].statistics.summary.outage.count > 0) {
                    result++;
                    break;
                }
            }
        }
        return result;
    }

    render() {
        const statistics = this.state.singleData && this.state.singleData[0] && this.state.singleData[0].statistics;
        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        let columns = this.buildColumns(true, this.state.groups);
        const { stateFilter } = this.state;

        const params = {
            aliases: this.state.alias.length ? ((this.state.alias.startsWith('\'') && this.state.alias.endsWith('\'')) || (this.state.alias.startsWith('\"') && this.state.alias.endsWith('\"'))) ? 'name' : 'name%' : 'name%',
            // tslint:disable-next-line:max-line-length
            name: this.state.alias.length ? ((this.state.alias.startsWith('\'') && this.state.alias.endsWith('\'')) || (this.state.alias.startsWith('\"') && this.state.alias.endsWith('\"'))) ? this.state.alias.slice(1, this.state.alias.length - 1) : this.state.alias : this.state.alias,
            namespace: 'api.surveyor.abr',
            timerange: '100 to current',
            // metrics: ['vod.name+id+status+streamType+assetName', 'vod.statistics.summary.mode+assetResult']
            metrics: ['vod.name+id+status+streamType+assetName+variants', 'vod.status.percentComplete+state', 'vod.statistics.summary.mode+assetResult+outage']
        };

        const stateOptions = [ { value: 'ALL', text: 'All' },
            { value: 'PASS', text: 'Good' },
            { value: 'ERROR', text: 'Error' },
            { value: 'FAIL', text: 'Fail' },
            { value: 'OUTAGE', text: 'Outage' }
        ];

        return (
            <div className="view-content scrollable" id="vodstatus">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Video On Demand Status</div>
                        </div>
                    </div>
                </div>
                <div className="filterPanel">
                    <Input
                        className="censusPageSearchBox"
                        placeholder="VOD Asset Alias"
                        value={this.state.alias}
                        onChange={(event, data) => this.setState({alias: data.value})}
                        icon={!this.state.alias ? <Icon /> : <Icon name="delete" link onClick={() => this.setState({alias: ''})} />}
                    />
                    <Dropdown
                        className="censusDropDown"
                        placeholder="State"
                        value={stateFilter}
                        search
                        selection
                        options={stateOptions}
                        onChange={(event, data) => this.setState({stateFilter: data.value})}
                    />
                    {/*<Dropdown*/}
                    {/*    className="eventTypeDropDown eventTypeDropDown-width200"*/}
                    {/*    // placeholder="Entry Type"*/}
                    {/*    multiple*/}
                    {/*    search*/}
                    {/*    labeled={false}*/}
                    {/*    searchInput={false}*/}
                    {/*    trigger={this.state.eventTypeFilterText.length > 0 ?*/}
                    {/*        <p className="eventTypeDropDownTrigger">{this.state.eventTypeFilterText.join(', ')}</p> :*/}
                    {/*        <p className="eventTypeDropDownTriggerLowOpacity">State</p>}*/}
                    {/*    selection*/}
                    {/*>*/}
                    {/*    <Dropdown.Menu>*/}
                    {/*        {stateTypeOptions.map(eOption => {*/}
                    {/*            return  <Dropdown.Item>*/}
                    {/*                <Checkbox key={eOption.text}*/}
                    {/*                          label={<label className={this.state.eventTypeFilter.includes(eOption.value) || this.state.eventTypeFilterAll ? 'assetName' : ''}*/}
                    {/*                              // SAN-4009 - The background color showed as green initially, this fix shows no background color*/}
                    {/*                                        style={{backgroundColor: 'rgba(255,255,255, 0)'}}>{eOption.text}*/}
                    {/*                          </label>}*/}
                    {/*                    // label={eOption.text}*/}
                    {/*                          name={eOption.text}*/}
                    {/*                          checked={eOption.value === 'all' ?*/}
                    {/*                              this.state.eventTypeFilterAll :*/}
                    {/*                              this.state.eventTypeFilter.includes(eOption.value)}*/}
                    {/*                          onChange={(event, data) => this.handleEventTypeCheckbox(event, data, eOption, stateTypeOptions)}*/}
                    {/*                          style={{width: '100%'}}*/}
                    {/*                />*/}
                    {/*            </Dropdown.Item>;*/}
                    {/*        })}*/}
                    {/*    </Dropdown.Menu>*/}
                    {/*</Dropdown>*/}
                </div>
                <div className="view-clientarea">
                    <section className="vodStatus-content">
                        <DataRequest
                            auto                // automatically request on data change (filter change)
                            spinner             // show spinner when foreground loading (ex. on first load)
                            debounce={350}     // debounce multiple requests (i.e. as user types in filter box)
                            interval={this.state.refreshRate}
                            method="post"
                            endpoint="api/analytics"
                            transform={VodStatusView.transformData}
                            data={params}
                            orderBy="order results.vod by id asc"
                        >{ (request: Response) => {
                            // save the refresh function for later use
                            // this.dataRefresh = request.refresh;

                            if (!request.data) {
                                // no data yet, show a dimmer screen
                                return <Dimmer active={true}><Loader/></Dimmer>;
                            }

                            let { queuedSet, inProgressSet, completedSet, pass, fail, error } = request.data
                                || { queuedSet: [], inProgressSet: [], completedSet: [], pass: 0, fail: 0, error: 0 };  // empty arrays if data hasnt loaded
                            let outage = 0;

                            // SAN-4737
                            let newFilteredSet = [];
                            if (completedSet.length > 0) {
                                // NOTE: get the outage count heree rather than the transform() method as it seemed to be too slow processing completed items.
                                // Are there any master/variant outages?
                                newFilteredSet = completedSet.filter((asset: any) => (asset.statistics.summary.outage.count > 0 || this.variantOutages(asset) > 0));
                                outage = newFilteredSet.length;
                                // subtract outages from fails for counts
                                fail = fail - outage;
                                // apply filter: PASS/ERROR/FAIL/OUTAGE
                                let filter = this.state.stateFilter;
                                if (filter !== 'ALL' && filter !== '') {
                                    if (filter === 'OUTAGE') {
                                        newFilteredSet = completedSet.filter((asset: any) => (asset.statistics.summary.outage.count > 0 || this.variantOutages(asset) > 0));
                                    } else if (filter === 'FAIL') {
                                        const regexp = new RegExp(filter, 'i');
                                        newFilteredSet = completedSet.filter((asset: any) => regexp.test(asset.statistics.summary.assetResult));
                                        // Filter out outages.
                                        newFilteredSet = newFilteredSet.filter((asset: any) => (asset.statistics.summary.outage.count === 0 && this.variantOutages(asset) === 0));
                                    } else { // GOOD/ERROR
                                        const regexp = new RegExp(filter, 'i');
                                        newFilteredSet = completedSet.filter((asset: any) => regexp.test(asset.statistics.summary.assetResult));
                                    }
                                } else {
                                    newFilteredSet = completedSet;
                                }
                            }

                            // render a react table using the request data
                            return (
                                <div className="vodStatus-columns">
                                    <main className="vodStatusSidebar-completed">
                                        <Table celled striped>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell/>
                                                    <Table.HeaderCell className="table-header">Complete
                                                        <Label className="countsRight" title="Complete" horizontal color="blue">{newFilteredSet.length}</Label>
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell className="table-header">Totals
                                                        <Label className="countsRight" title="Good" horizontal color="green">{pass}</Label>
                                                        <Label className="countsRight" title="Error" horizontal color="orange"> {error}</Label>
                                                        <Label className="countsRight" title="Fail" horizontal color="red"> {fail}</Label>
                                                        <Label className="countsRight" title="Outage" horizontal color="black"> {outage}</Label>
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.HeaderCell/>
                                                    <Table.HeaderCell colspan="2">Name</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {(newFilteredSet.length > 0) ?
                                                    newFilteredSet.map((object: any, i: number) =>
                                                        <Table.Row key={i} className="assetName-cell">
                                                            <Table.Cell className="table-icon-column" title={this.streamState(object, 1)}>
                                                                {/* tslint:disable-next-line:max-line-length */}
                                                                <FontAwesome name={((object.statistics && object.statistics.summary) ? object.statistics.summary.assetResult === 'PASS' ? 'fas fa-check' : object.statistics.summary.assetResult === 'FAIL' ? 'fas fa-exclamation' : 'fas fa-exclamation' : 'fas fa-check' )} style={{color: this.streamState(object, 2)}}/>
                                                            </Table.Cell>
                                                            <Table.Cell
                                                                title="Click to display more details"
                                                                colspan="2"
                                                            >
                                                                <NavLink
                                                                    style={{ textDecoration: 'underline' }}
                                                                    to={{
                                                                        pathname: '/monitoring/vodCensus',
                                                                        state: { streamName: object.name }
                                                                    }}
                                                                >
                                                                {object.name}
                                                                </NavLink>
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    )
                                                    :
                                                    <Table.Row>
                                                        <Table.Cell/>
                                                        <Table.Cell className="vodStatus-text">
                                                            No test results in the last 15 minutes
                                                        </Table.Cell>
                                                    </Table.Row>
                                                }
                                            </Table.Body>
                                        </Table>
                                    </main>
                                    <aside className="vodStatusSidebar-scheduled">
                                        <Table celled striped>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell className="table-header">Scheduled
                                                        <Label className="countsRight" title="Scheduled" horizontal color="blue">{queuedSet.length}</Label>
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {(queuedSet.length > 0 || inProgressSet.length > 0 || completedSet.length > 0 ) ?
                                                    queuedSet.map((object: any, i: number) =>
                                                        <Table.Row key={i}>
                                                            <Table.Cell>
                                                                {object.name}
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    )
                                                    :
                                                    <Table.Row>
                                                        <Table.Cell className="vodStatus-text">
                                                            No tests are scheduled
                                                        </Table.Cell>
                                                    </Table.Row>
                                                }
                                            </Table.Body>
                                        </Table>
                                    </aside>
                                    <aside className="vodStatusSidebar-inProgress">
                                        <Table celled striped>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell className="table-header">In Progress
                                                        <Label className="countsRight" title="In Progress" horizontal color="blue">{inProgressSet.length}</Label>
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {(inProgressSet.length > 0) ?
                                                    inProgressSet.map((object: any, i: number) =>
                                                        <Table.Row key={i}>
                                                            <Table.Cell
                                                                // className={(object.state !== 'TESTING' ? 'white-out' : '')}
                                                                title={object.status.percentComplete + '%'}
                                                            >
                                                                {object.name}
                                                                {Renderers.percent.progress(object.status.percentComplete)}
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    )
                                                    :
                                                    <Table.Row>
                                                        <Table.Cell className="vodStatus-text">
                                                            No tests are streaming
                                                        </Table.Cell>
                                                    </Table.Row>
                                                }
                                            </Table.Body>
                                        </Table>
                                    </aside>
                                </div>
                            );
                        }}
                        </DataRequest>
                    </section>

                    {/*<PortalView active={this.state && this.state.showTestDetailsWindow} closeWindowPortal={this.closeTestDetailsWindowPortal}>*/}
                    {/*    <TestDetailsView streamid={this.state.streamId} streamName={this.state.streamName} />*/}
                    {/*</PortalView>*/}

                    <Modal
                        open={this.state.showModal}
                        onClose={this.handleModalClose}
                        size="fullscreen"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>{this.state.stream.name}</Modal.Header>
                        <Modal.Content>
                            <fieldset id="fieldSet">
                                <legend>Summary</legend>
                                <Table celled striped>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell>Result</Table.Cell>
                                            <Table.Cell>Test Mode</Table.Cell>
                                            <Table.Cell>Variants Detected</Table.Cell>
                                            <Table.Cell>Variants Tested</Table.Cell>
                                            <Table.Cell>Variants Failed</Table.Cell>
                                            <Table.Cell>Start Time (hh:mm:ss)</Table.Cell>
                                            <Table.Cell>Test Duration (hh:mm:ss)</Table.Cell>
                                            <Table.Cell>Download Size (MB)</Table.Cell>
                                            {/*<Table.Cell>Total Errors</Table.Cell>*/}
                                        </Table.Row>
                                        {(statistics && statistics.summary && statistics.vod) ?
                                            <Table.Row>
                                                <Table.Cell>{this.passFailRenderer(statistics.summary, true)}</Table.Cell>
                                                <Table.Cell>{this.formatMode(statistics.summary.mode)}</Table.Cell>
                                                <Table.Cell>{statistics.summary.testing.total}</Table.Cell>
                                                <Table.Cell>{statistics.summary.testing.tested}</Table.Cell>
                                                <Table.Cell>{statistics.summary.testing.failed}</Table.Cell>
                                                <Table.Cell>{Renderers.timestamp.calendar(statistics.summary.startTime)}</Table.Cell>
                                                <Table.Cell>{Renderers.timestamp.durationHMS(statistics.summary.stopTime - statistics.summary.startTime, false)}</Table.Cell>
                                                {/*<Table.Cell>{this.renderDLSizeMB(statistics.files.manifest.bytes)}</Table.Cell>*/}
                                                <Table.Cell>{this.renderDLSizeMB(0)}</Table.Cell>
                                                {/*<Table.Cell>{this.totalErrors(statistics.summary, true)}</Table.Cell>*/}
                                            </Table.Row>
                                            : Array(8).map((c, i) => <Table.Cell key={i}>&nbsp;</Table.Cell>)    // if statistics is invalid or null
                                        }
                                    </Table.Body>
                                </Table>
                            </fieldset>
                            <fieldset id="fieldSet">
                                {/*<legend>Errors</legend>*/}
                                <Table celled striped>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.HeaderCell/>
                                            <Table.HeaderCell width={4}>Stream</Table.HeaderCell>
                                            <Table.HeaderCell>Alarms</Table.HeaderCell>
                                        </Table.Row>
                                        {(statistics && statistics.summary && statistics.vod) ?
                                            <Table.Row>
                                                <Table.Cell className="table-icon-column">
                                                    <Dropdown item icon="bars" simple>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => this.openManifestWindow(this.state.singleData[0], false)}
                                                            >
                                                                Manifests
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                as={Link}
                                                                to={{
                                                                    pathname: '/logs/transaction',
                                                                    state: {
                                                                        streamid: this.state.singleData[0].id.streamId,
                                                                        name: this.state.singleData[0].name
                                                                    }
                                                                }}
                                                            >
                                                                Transaction Log
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </Table.Cell>
                                                <Table.Cell>{this.state.stream.name}</Table.Cell>
                                                <Table.Cell>{this.errorsText(statistics.summary)}</Table.Cell>
                                            </Table.Row>
                                            : Array(3).map((c, i) => <Table.Cell key={i}>&nbsp;</Table.Cell>)    // if statistics is invalid or null
                                        }
                                    </Table.Body>
                                </Table>
                            </fieldset>
                            <Segment id="fieldSet">
                                <Group.Set
                                    className="column-groups"
                                    defaultChecked={false}
                                    onChange={(set: Array<string>) => this.setState({groups: set})}
                                >
                                    <Group.Field id="Summary" defaultValue={true}>Summary</Group.Field>
                                    <Group.Field id="HTTP">HTTP Code</Group.Field>
                                    <Group.Field id="MediaFiles">Media Files</Group.Field>
                                    <Group.Field id="Accessibility">Accessibility</Group.Field>
                                    <Group.Field id="ABRProtocol">ABR Protocol</Group.Field>
                                    <Group.Field id="QOE">Quality of Experience</Group.Field>
                                </Group.Set>

                                <ReactTable
                                    onFetchData={() => this.fetchSingleStreamData(this.state.stream)}
                                    data={(this.state && this.state.singleData[0]) ? this.state.singleData[0].variants : []}
                                    columns={columns}
                                    PaginationComponent={CustomPagination}
                                    defaultPageSize={16}
                                />
                            </Segment>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                className="filterPanel-primary-btn modal-button-padding"
                                onClick={this.handleModalClose}
                            >
                                OK
                            </Button>
                        </Modal.Actions>
                    </Modal>

                    <PortalView active={this.state && this.state.showManifestWindow} closeWindowPortal={this.closeManifestWindowPortal}>
                        <ManifestView vod streamid={this.state.streamId} streamName={this.state.streamName}/>
                    </PortalView>

                    <PortalView active={this.state && this.state.showMIMEHeaderWindow} closeWindowPortal={this.closeMIMEHeaderWindowPortal}>
                        <MIMEHeaderView vod streamid={this.state.streamId} streamName={this.state.streamName}/>
                    </PortalView>

                    <PortalView active={this.state && this.state.showMediaFileWindow} closeWindowPortal={this.closeMediaFileWindowPortal}>
                        <MediaFileView vod streamid={this.state.streamId} streamName={this.state.streamName} mode="VOD"/>
                    </PortalView>

                </div>
            </div>

        );
    }
}
/* */


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/monitoring/vodStatus.tsx